module.exports = __webpack_public_path__ + "static/media/05.dd7fbed8.jpg";